module.exports = __webpack_public_path__ + "static/media/send.e0d2ce47.svg";